<template src="./BotDetail.template.html"></template>
<script>
  import { IntegerPlusminus } from 'vue-integer-plusminus';
  import foliomodal from "../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";

  export default {
    components: {
      foliomodal,
      IntegerPlusminus
    },
    name: "BotDetail",
    props: [""],
    data() {
      return {
        unitToggle: true,
        sourceToggle: true,
        unitTypeToggle: true,
        propertyToggle: true,
        propertyLabel: {},
        sourceLabel: {},
        unitLabel: {},
        defaultEntity: null,
        isBgColor1: true,
        isBgColor2: false,
        isBgColor3: false,
        isBgColor4: false,
        isBgColor5: false,

        displaySectionValue: "BotDetails",
        botdetails: {
          NoofDays: 0,
          NoofHours: 0
        },
        statusList: [],
        BotType_Id: "-99",
        Bot_Status: {},
        TemplateTypes: [],
        Templates: [],
        propertyList: [],
        property: {},
        temp: {
          TemplateId: -1
        },
        Entities: [],
        entity: {},
        Event: {},
        PEvent: {},
        BotEvents: [],
        checkedTemp: [],
        checkedCategories: [],
        checkedCategoriesTypes: "",
        NumberofDays: 0,
        TransactionType: [],
        TransactionTypeobj: {},
        AmountToCollect: [],
        AmountObj: {},
        sourcesList: [],
        NotificationList: [],
        ApplySourceList: [],
        ApplyNotifyList: [],
        Paymentproperty: {},
        selectedSourceIds: [],
        SubEventObj: {},
        selectedSubEventIdList: [],
        prevoiusSelectedSubEventIdList: [],
        // schedular: "Now",
        // type: '',
        // DateType: [{
        //   name: "Arrival date",
        //   DateTypeId: 1,
        // },
        // {
        //   name: "Departure Date",
        //   DateTypeId: 2,
        // },
        // {
        //   name: "Booked on",
        //   DateTypeId: 3
        // }],
        Bot_Status: {

        },

        schedular: [{
          name: "on",
          SubEventId: 11,


        },
        {
          name: "Before",
          SubEventId: 12,

        },
        {
          name: "After",
          SubEventId: 13,


        }],
        SubEventList: [],

        Statuses: [{
          SubEventId: 3,
          StatusName: "Confirmend",
          IsChecked: false
        },
        {
          SubEventId: 4,
          StatusName: "Guarented",
          IsChecked: false
        },
        {
          SubEventId: 5,
          StatusName: "Cancelled",
          IsChecked: false
        }

        ],
        IsChecked: false,
        name: "",
        displayEvent: false,
        displaySubEvent: false,
        BeforeIsChecked: false,
        showNumberofDays: false,
        showAmountlabel: false,
        SubEventid: -1,
        botTypedisable: false,
        BotType: [],
        BotId: -1,
        sourceids: [],
        selectsourcesids: [],
        schedularobj: {},
        displayStatus: false,
        filteredUnitTypeList: [],
        unitTypeList: [],
        filteredUnitList: [],
        unitList: [],
        filterSearchUnitNameText: null,
        filterSearchUnitTypeNameText: null,
        filteredScopeData: [],
        filteredPropertyList: [],
        filterSearchPropertyNameText: null,
        templateList: [],
        Templatevalueee: {},
        searchTemplate: "",
        searchTemplateOldValue: "",
        selectedTemplate: {},
        getList: false,
        isModalVisible: false,
        modalParams: {},
        saveBotAction: ""
      };


    },
    methods: {
      getSearchList() {
        let vm = this;
        console.log("hereGet_TemplatesList")
        vm.getList = false;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_TemplatesList",
          params: {
            ModuleAction: "Get_TemplatesList",
            StatusId: 1,
            SearchText: vm.searchTemplate
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("response in search template", response);
              vm.templateList = response;
              vm.getList = true;
            }
          }
        });
      },
      ApplyPropertyListStr(filteredPropertyList) {
        let vm = this;
        if (filteredPropertyList.length > 0) {
          let val = filteredPropertyList.map(x => x.PropertyName);
          return val.join(", ");
        } else {
          return "All Properties"
        }
      },
      ApplyNotifyListStr(ApplyNotifyList) {
        if (ApplyNotifyList.length > 0) {
          let val = ApplyNotifyList.map(x => x.RecepientName);
          return val.join(", ");
        } else {
          return ""
        }
      },
      ApplySourceListStr(ApplySourceList) {
        if (ApplySourceList.length > 0) {
          let val = ApplySourceList.map(x => x.sourceName);
          return val.join(", ");
        } else {
          return "All Sources"
        }
      },

      ApplyUnitTypeListStr(filteredUnitTypeList) {
        if (filteredUnitTypeList.length > 0) {
          let val = filteredUnitTypeList.map(x => x.UnitTypeName);
          return val.join(", ");
        } else {
          return "All Unit Types"
        }
      },
      ApplyUnitListStr(filteredUnitList) {
        if (filteredUnitList.length > 0) {
          let val = filteredUnitList.map(x => x.UnitName);
          return val.join(", ");
        } else {
          return "All Units"
        }
      },
      // ApplyUnitListStr
      ShowAmountToCollect(AmountId) {
        let vm = this;
        if (AmountId) {
          vm.showAmountlabel = true;
          if (AmountId == 5 || AmountId == 6) {
            vm.botdetails.IsPercent = 1;
            vm.showAmountlabel = true;
          }
          else {
            vm.botdetails.IsPercent = 0
          }
        }
        else {
          vm.showAmountlabel = false;

        }
      },

      // addSource(source) {

      //   let scope = this;
      //   // scope.ApplySourceList.push({
      //   //   sourceID: source.sourceID,
      //   //   sourceName: source.sourceName
      //   // });
      //   // vm.selectedSourceIds.push{}
      //   // if (scope.sourcesList.length > 0) {

      //   scope.ApplySourceList.push(source);
      //   // scope.selectsourcesids = scope.selectedSourceIds.join(",");
      //   console.log("selectsourcesids", scope.selectsourcesids);
      //   // }
      //   // }
      //   // var index = scope.sourcesList.indexOf(source);
      //   // console.log("index of Amenities=>", index);
      //   // if (index > -1) {
      //   //   scope.sourcesList.splice(index, 1);
      //   //   console.log("scope.sourcesList", scope.sourcesList);
      //   // }
      // },
      // removeAppliedSourceList(source) {
      //   console.log("source", source)
      //   let scope = this;
      //   // var index = scope.ApplySourceList.indexOf(source);
      //   // console.log("index============>", index);
      //   // if (index > -1) {
      //   //   scope.ApplySourceList.splice(index, 1);
      //   //   console.log(
      //   //     "delete  scope.ApplySourceList",
      //   //     scope.ApplySourceList
      //   //   );
      //   // }
      //   // scope.sourcesList.push({
      //   //   sourceID: source.sourceID,
      //   //   sourceName: source.sourceName
      //   // });
      //   // console.log("scope.sourcesList after deleting", scope.sourcesList);
      //   // vm.selectedSourceIds.splice(source.sourceID);
      //   for (var i = 0; i < scope.ApplySourceList.length; i++) {
      //     console.log("scope.ApplySourceList[i].SourceId", scope.ApplySourceList[i].sourceId + "+++++" + source.sourceId)
      //     if (scope.ApplySourceList[i].sourceId == source.sourceId) {
      //       scope.ApplySourceList.splice(i, 1);
      //     }
      //   }
      // },
      addSource(source) {
        let scope = this;
        scope.ApplySourceList.push({
          sourceId: source.sourceId,
          sourceName: source.sourceName
        });
        var index = scope.sourcesList.indexOf(source);
        console.log("index of Amenities=>", index);
        if (index > -1) {
          scope.sourcesList.splice(index, 1);
          console.log("scope.sourcesList", scope.sourcesList);
        }
      },
      removeAppliedSourceList(source) {
        let scope = this;
        var index = scope.ApplySourceList.indexOf(source);
        console.log("index============>", index);
        if (index > -1) {
          scope.ApplySourceList.splice(index, 1);
          console.log(
            "delete  scope.ApplySourceList",
            scope.ApplySourceList
          );
        }
        scope.sourcesList.push({
          sourceId: source.sourceId,
          sourceName: source.sourceName
        });
        console.log("scope.AmenitiesList after deleting", scope.sourcesList);
      },

      addProperty(property) {
        let vm = this;
        vm.filteredPropertyList.push(property);
        var index = vm.propertyList.indexOf(property);
        console.log("index of Amenities=>", index);
        if (index > -1) {
          vm.propertyList.splice(index, 1);
          // console.log("scope.unitTypeList", vm.unitTypeList);
        }
        vm.getUnit_unitType_List();
      },
      removeFilteredProperty(property) {
        let scope = this;
        var index = scope.filteredPropertyList.indexOf(property);
        console.log("index============>", index);
        if (index > -1) {
          scope.filteredPropertyList.splice(index, 1);
        }
        scope.propertyList.push(property);
        console.log("scope.AmenitiesList after deleting", scope.propertyList);
        scope.getUnit_unitType_List();
      },

      addUnitType(unitType) {
        let vm = this;
        vm.filteredUnitTypeList.push(unitType);
        var index = vm.unitTypeList.indexOf(unitType);
        console.log("index of Amenities=>", index);
        if (index > -1) {
          vm.unitTypeList.splice(index, 1);
          // console.log("scope.unitTypeList", vm.unitTypeList);
        }

      },
      removeFilteredUnitTypes(unitType) {
        let vm = this;
        var index = vm.filteredUnitTypeList.indexOf(unitType);
        console.log("index of Amenities=>", index);
        if (index > -1) {
          vm.filteredUnitTypeList.splice(index, 1);
          // console.log("scope.unitTypeList", vm.filteredUnitTypeList);
        }
        vm.unitTypeList.push(unitType);
      },

      addUnit(unit) {
        let vm = this;
        vm.filteredUnitList.push(unit);
        var index = vm.unitList.indexOf(unit);
        console.log("index of Amenities=>", index);
        if (index > -1) {
          vm.unitList.splice(index, 1);
          console.log("scope.unitTypeList", vm.unitList);
        }
      },

      removeFilteredUnits(unit) {
        let vm = this;
        var index = vm.filteredUnitList.indexOf(unit);
        console.log("index of Amenities=>", index);
        if (index > -1) {
          vm.filteredUnitList.splice(index, 1);
          // console.log("scope.unitTypeList", vm.filteredUnitTypeList);
        }
        vm.unitList.push(unit);
      },

      showSourceListFnc(filterCol) {
        let vm = this;
        setTimeout(function () {
          vm.dropDownList = !vm.dropDownList;
          $("#sourceDropdownlist").show();
        }, 10);

      },
      showDropDown(filterCol) {
        let vm = this;
        setTimeout(function () {
          if (filterCol == 'property') {
            vm.getPropertiesBySearchText();
            $("#propertyDropdownlist").show();
          }
          if (filterCol == 'unitType') {
            vm.getUnitTypeList();
            $("#unitTypeDropdownlist").show();
          }
          if (filterCol == 'unit') {
            if (vm.botdetails.IsHostMode == 1) {
              vm.getUnitNamesBySearchText();
            } else {
              vm.Get_UnitsAssociated_ToUnitType();
            }
            $("#unitDropdownlist").show();
          }
        }, 10);
      },
      getUnit_unitType_List() {
        let vm = this;
        if (vm.botdetails.IsHostMode == 1) {
          vm.getUnitNamesBySearchText(null, "propertyChange");

        } else {
          vm.getUnitTypeList(null, "propertyChange")
        }
      },
      getPropertiesBySearchText(searchText) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetPropertiesBySearchText",
          params: {
            searchText: searchText
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);
            }
            // vm.getReservationDetailById();
            for (var property of vm.filteredPropertyList) {
              let index = vm.propertyList.findIndex(
                x => x.PropertyId == property.PropertyId
              );
              if (index > -1) {
                vm.propertyList.splice(index, 1);
              }
            }
          }
        });
      },
      getUnitTypeList(searchText, changeName) {
        let vm = this;
        let propertyIds = (vm.filteredPropertyList && vm.filteredPropertyList.length && vm.filteredPropertyList[0].PropertyId) ? vm.filteredPropertyList.map(x => x.PropertyId) : []
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_UnitTypeList",
          params: {
            sortBy: null,
            sortOrder: null,
            propertyId: propertyIds ? propertyIds.toString() : -1,
            statusId: 1,
            searchText: searchText,
            FromSetup: false
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("Get_UnitTypeList==>", response);
              if (response[1] && response[1].length > 0) {
                vm.unitTypeList.splice(0, vm.unitTypeList.length, ...response[1]);
              }
              if (changeName === "getList") {
                for (let unit of vm.filteredScopeData) {

                  if (unit.UnitsetId == 3) {
                    console.log("vm.unitTypeList.map(unitType => unitType.UnitTypeId)", vm.unitTypeList.map(x => x.UnitTypeId));

                    var index = vm.unitTypeList.map(x => x.UnitTypeId).indexOf(unit.UnitId);
                    if (index > -1) {
                      vm.filteredUnitTypeList.push(vm.unitTypeList[index]);
                    }
                  }
                }
              }
              if (changeName === "propertyChange") {
                if (propertyIds.length > 0) {
                  vm.filteredUnitTypeList.splice(0, vm.filteredUnitTypeList.length, ...vm.unitTypeList);
                }
                else {
                  vm.filteredUnitTypeList.splice(0);
                }
              }

              console.log("vm.filteredUnitTypeList", vm.filteredUnitTypeList);
              for (var unitType of vm.filteredUnitTypeList) {
                let index = vm.unitTypeList.findIndex(
                  x => x.UnitTypeId == unitType.UnitTypeId
                );
                if (index > -1) {
                  vm.unitTypeList.splice(index, 1);
                }
              }
              if (vm.filteredUnitTypeList.length > 0 || vm.filteredUnitList.length > 0) {
                vm.unitToggle = false;
              }
            }
          }
        });
      },
      getUnitNamesBySearchText(searchText, changeName) {
        let vm = this;
        // let resultObj = vm.filterObj.Properties.map(obj => obj.PropertyId);
        let propertyIds = (vm.filteredPropertyList && vm.filteredPropertyList.length && vm.filteredPropertyList[0].PropertyId) ? vm.filteredPropertyList.map(x => x.PropertyId) : []
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetUnitListBySearchText",
          params: {
            searchText: searchText,
            PropertyId: propertyIds ? propertyIds.toString() : null,
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              let List = response.unitList;
              if (changeName == "getList") {
                for (let unit of vm.filteredScopeData) {
                  if (unit.UnitsetId == 1) {
                    var index = List.map(x => x.UnitId).indexOf(unit.UnitId);
                    if (index > -1) {
                      vm.filteredUnitList.push(List[index]);
                    }
                  }
                }
              }
              if (changeName === "propertyChange") {
                if (propertyIds.length > 0) {
                  vm.filteredUnitList.splice(0, vm.filteredUnitList.length, ...List);
                } else {
                  vm.filteredUnitList.splice(0)
                }
              }
              for (var i = 0; i < vm.filteredUnitList.length; i++) {

                let index = List.findIndex(
                  x => x.UnitId == vm.filteredUnitList[i].UnitId
                );
                if (index > -1) List.splice(index, 1);
                console.log("index", index);
              }
              vm.unitList.splice(0, vm.unitList.length, ...List);
              if (vm.filteredUnitTypeList.length > 0 || vm.filteredUnitList.length > 0) {
                vm.unitToggle = false;
              }
            }
          }
        });
      },
      Get_UnitsAssociated_ToUnitType() {
        let vm = this;
        //
        // filterObj.unitTypes
        console.log("filterObj.unitTypes", vm.filterObj.unitTypes);
        let resultObj = vm.filterObj.unitTypes.map(obj => obj.UnitTypeId);
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_UnitsAssociated_ToUnitType",
          params: {
            ModuleAction: "Get_UnitsAssociated_ToUnitType",
            unitTypeId: resultObj.toString()
          },
          callback: function (err, response) {
            if (err) {
              console.log("error in Get_UnitsAssociated_ToUnitType", err);
            }
            if (response) {
              console.log("response of Get_UnitsAssociated_ToUnitType", response);
              vm.unitList = [];
              if (response[0] && response[0].length > 0) {
                vm.unitList = response[0];
                let List = response[0];
                for (var i = 0; i < vm.filteredUnitList.length; i++) {

                  let index = List.findIndex(
                    x => x.UnitId == vm.filteredUnitList[i].UnitId
                  );
                  if (index > -1) List.splice(index, 1);
                  console.log("index", index);
                }
                vm.unitList.splice(0, vm.unitList.length, ...List);
              }
            }
          }
        });
      },

      addNotification(notify) {
        let scope = this;
        scope.ApplyNotifyList.push({
          Id: notify.Id,
          RecepientName: notify.RecepientName
        });
        var index = scope.NotificationList.indexOf(notify);
        console.log("index of Amenities=>", index);
        if (index > -1) {
          scope.NotificationList.splice(index, 1);
          console.log("scope.NotificationList", scope.NotificationList);
        }
      },
      removeAppliednotifyList(notify) {
        let scope = this;
        var index = scope.ApplyNotifyList.indexOf(notify);
        console.log("index============>", index);
        if (index > -1) {
          scope.ApplyNotifyList.splice(index, 1);
          console.log(
            "delete  scope.ApplyNotifyList",
            scope.ApplyNotifyList
          );
        }
        scope.NotificationList.push({
          Id: notify.Id,
          RecepientName: notify.RecepientName
        });
        console.log("scope.AmenitiesList after deleting", scope.NotificationList);
      },
      shownotifyListFnc() {
        setTimeout(function () {
          this.Notifydropdownlist = !this.Notifydropdownlist;
          $("#Notifydropdownlist").show();
        }, 10);

      },

      saveSubEvent(id) {
        let vm = this;
        console.log("instinstinst===========================>", id);
        vm.SubEventid = id;
        console.log("")

      },
      displaySection(name) {
        let vm = this;
        if (name == "BotDetails") {
          vm.isBgColor1 = true,
            vm.isBgColor2 = false,
            vm.isBgColor3 = false,
            vm.isBgColor4 = false,
            vm.isBgColor5 = false,
            vm.displaySectionValue = name;

        }
        if (name == "BotType") {
          vm.isBgColor1 = false,
            vm.isBgColor2 = true,
            vm.isBgColor3 = false,
            vm.isBgColor4 = false,
            vm.isBgColor5 = false,
            vm.displaySectionValue = name;

        }
        // if (name == "propertyDetails") {
        //   vm.isBgColor3 = true,
        //     vm.isBgColor1 = false,
        //     vm.isBgColor2 = false,
        //     vm.isBgColor4 = false,
        //     vm.isBgColor5 = false,
        //     vm.displaySectionValue = name;
        // }
        if (name == "PaymentBotType") {

          vm.isBgColor1 = false,
            vm.isBgColor2 = false,
            vm.isBgColor3 = false,
            vm.isBgColor4 = true,
            vm.isBgColor5 = false,
            vm.displaySectionValue = name;
        }
        if (name == "PaymentPropertyDetails") {
          vm.isBgColor1 = false,
            vm.isBgColor2 = false,
            vm.isBgColor3 = false,
            vm.isBgColor4 = false,
            vm.isBgColor5 = true,
            vm.displaySectionValue = name;
        }

      },
      addEvent(inst) {
        let vm = this;
        vm.SubEventObj = "";
        console.log(" ", inst)
        // if (inst.BotEvent_Id == 3 || inst.BotEvent_Id == 4 || inst.BotEvent_Id == 1) {
        vm.displayEvent = true;
        vm.showNumberofDays = false;
        vm.botdetails.NoofDays = 0;
        vm.botdetails.NoofHours = 0;

        // }
        // else if(inst.BotEvent_Id== 1){
        //   vm.displayEvent = true;
        //   vm.showNumberofDays= false;
        //   vm.NumberofDays = 0;
        // }


        // if(inst.BotEvent_Id == 3){
        //   vm.displayEvent = true;
        //   // vm.showNumberofDays = false;
        //   // vm.NumberofDays = 0;
        // }

        //  if( inst.BotEvent_Id == 4 || inst.BotEvent_Id == 5 ){
        //   vm.displayEvent = false;
        //   vm.showNumberofDays = true;
        // }
        // else if (inst.BotEvent_Id == 1) {
        //   vm.displaySubEvent = true;
        //   vm.displayEvent = false;
        //   vm.NumberofDays = 0;
        //   vm.showNumberofDays = false;
        // }

        // else {
        //   // vm.displayEvent = false;
        //   vm.displaySubEvent = false;
        //   vm.showNumberofDays = false;
        //   vm.NumberofDays = 0;
        // }
        // else if (name == "Booked on") {
        //   vm.botdetails.Days = "";
        //   vm.ArrivalDate = false;
        //   vm.IsChecked = false;
        // }
        if (inst.BotEvent_Id) {
          vm.$store.dispatch("dataRequestHandler", {
            key: "Get_SubEvents_ByEventId",
            params: {
              EventId: inst.BotEvent_Id,
              BotType_Id: vm.botdetails.BotType_Id
            },
            callback: function (err, response) {
              if (err) {
                return;
              }
              if (response && response.recordsets.length > 0) {
                vm.selectedSubEventIdList.splice(0);

                vm.SubEventList.splice(0, vm.SubEventList.length, ...response.recordsets[0]);
                console.log("vm.SubEventList", vm.SubEventList);
                if (inst.BotEvent_Id == vm.botdetails.EventId) {
                  vm.selectedSubEventIdList.splice(0, vm.selectedSubEventIdList.length, ...vm.prevoiusSelectedSubEventIdList)
                }
              }
            }
          });
        }
      },

      schedularr(inst, e) {
        let vm = this;
        console.log("idddddddddddd", inst);

        if (e.target.checked) {
          vm.selectedSubEventIdList.push(inst.SubEventId)
        } else {
          var subEventIndex = vm.selectedSubEventIdList.findIndex(x => x == inst.SubEventId);
          vm.selectedSubEventIdList.splice(subEventIndex, 1)
        }

        // if (inst.SubEventId == 6 || inst.SubEventId == 7 || inst.SubEventId == 9 || inst.SubEventId == 10) {
        //   vm.showNumberofDays = true;
        // }
        // else {
        //   vm.showNumberofDays = false;
        //   vm.botdetails.NoofDays = 0;
        //   vm.botdetails.NoofHours = 0;
        // }
      },

      setToDefaultRes(inst) {
        console.log("instinstinstinst==>", inst);
      },
      Save_BotDescription() {
        let vm = this;
        if (vm.botdetails.BotType_Id == "" || vm.botdetails.BotType_Id == null || vm.botdetails.BotType_Id == undefined || vm.botdetails.BotName == "" || vm.botdetails.BotName == null || vm.botdetails.BotName == undefined) {
          vm.$store.dispatch("toastr", {
            type: "warning",
            message: "Please select bot type and enter bot name!",
            header: "Warning"
          });
          return
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_BotDescription",
          params: {
            BotId: vm.BotId,
            BotTypeId: vm.botdetails.BotType_Id,
            BotName: vm.botdetails.BotName,
            BotDescription: vm.botdetails.BotDescription ? vm.botdetails.BotDescription : "",
            StatusId: vm.Bot_Status.StatusId

          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("response in Botttttttttttttt", response);
              if (response.recordsets[1][0].BotId) {
                vm.botTypedisable = true;
              }
              if (
                response[0] &&
                response[0].length > 0 &&
                response[0][0].ErrorMessage
              ) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  message: "Error!",
                  header: "Error"
                });
              } else if (vm.botdetails.BotType_Id == 1) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  message: "Messanger BotType Saved Sucessfully",
                  header: "success"
                });
              }
              else if (vm.botdetails.BotType_Id == 2) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  message: "Payment BotType Saved Sucessfully",
                  header: "success"
                });
              }


              vm.BotId = response.recordsets[1][0].BotId
              console.log("vm.BotId=============>", vm.BotId)
              vm.$router.push(
                "/BotDetail/" + vm.BotId
              );
              vm.Get_BotDetails();
            }
          }
        });
      },



      Save_BotDetails(botsUpdate) {
        let vm = this;
        if (vm.Event.BotEvent_Id) {
          if (vm.selectedSubEventIdList.length == 0) {
            vm.$store.dispatch("toastr", {
              type: "warning",
              message: "Please select the sub event ",
              header: "Warning"
            });
            return
          }
        }
        let templateTypeIds = []
        for (let templatetype of vm.TemplateTypes) {
          if (vm.selectedTemplate.TemplateId == templatetype.TemplateId && (templatetype.IsChecked == "1" || templatetype.IsChecked == 1 || templatetype.IsChecked == true)) {
            templateTypeIds.push(templatetype.TemplateTypeId);
          }
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_BotDetails",
          params: {
            BotId: vm.$route.params.BotId,
            BotTypeId: vm.botdetails.BotType_Id,
            // TemplateId: vm.temp.TemplateId,
            TemplateId: vm.selectedTemplate.TemplateId,
            TemplateTypeId: templateTypeIds ? templateTypeIds.join() : null,
            EntityId: vm.entity.EntityId,
            EventId: vm.Event.BotEvent_Id,
            Recepients: vm.ApplyNotifyList,
            SubeventId: vm.selectedSubEventIdList ? vm.selectedSubEventIdList.join() : null,
            AmountPatternId: vm.AmountObj.PatternId,
            AmountToCollect: vm.botdetails.Amount,
            TransactionTypeId: vm.TransactionTypeobj.transactionTypeID,
            IsPercent: vm.botdetails.IsPercent,
            NoOfDays: vm.botdetails.NoofDays,
            NoOfHours: vm.botdetails.NoofHours,
            AfterNoofDays: vm.botdetails.AfterNoofDays,
            AfterNoofHours: vm.botdetails.AfterNoofHours,
            botsUpdate: botsUpdate ? 1 : 0
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("response in Botttttttttttttt", response);

              if (
                response.recordsets[0] &&
                response.recordsets[0].length > 0 &&
                response.recordsets[0][0].ErrorMessage
              ) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  message: response.recordsets[0][0].ErrorMessage,
                  header: "Error"
                });
              } else if (vm.botdetails.BotType_Id == 1) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  message: "MessangerBot Details saved sucessfully",
                  header: "success "
                });
              }
              else if (vm.botdetails.BotType_Id == 2) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  message: "PaymentBot Details saved sucessfully",
                  header: "success "
                });
              }
              vm.isModalVisible = false;
              vm.Get_BotDetails();
            }
          }
        });
      },
      // SaveTemplate(TemplateTypeId) {
      //   let vm = this;
      //    console.log("TemplateTypeId",TemplateTypeId)
      //    var selected = [];
      //    selected.push(TemplateTypeId);
      //    if (selected.length > 0) {
      //           alert("Selected values: " + selected.join(","));

      //       }
      // },
      SaveTemplate(TemplateTypeId, IsChecked) {
        let vm = this;
        console.log("TemplateTypeId=====================>", TemplateTypeId)
        if (TemplateTypeId && IsChecked) {
          vm.checkedCategories = [];
          if (vm.TemplateTypes.length > 0) {
            for (
              let TemplateTypesIndex = 0;
              TemplateTypesIndex < vm.TemplateTypes.length;
              TemplateTypesIndex++
            ) {
              if (Number(vm.TemplateTypes[TemplateTypesIndex]["IsChecked"]))
                vm.checkedCategories.push(
                  vm.TemplateTypes[TemplateTypesIndex]["TemplateTypeId"]
                );
              vm.checkedCategoriesTypes = vm.checkedCategories.join(",");
              console.log("checkedCategoriesTypes", vm.checkedCategoriesTypes);
            }
          }

        }


      },


      Get_BotDetails() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_BotDetails",
          params: {
            BotId: vm.$route.params.BotId,
            BotType_Id: vm.botdetails.BotType_Id
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("Get_BotDetails", response);


              if (response && response.recordsets[0]) {
                vm.statusList = response.recordsets[0]
              }
              if (response && response.recordsets[1]) {
                vm.BotType = response.recordsets[1]
              }
              if (response && response.recordsets[2]) {
                vm.Entities = response.recordsets[2]
              }
              if (response && response.recordsets[3]) {
                vm.BotEvents = response.recordsets[3]
              }
              if (response && response.recordsets[4]) {
                vm.TransactionType = response.recordsets[4]
              }
              if (response && response.recordsets[5]) {
                vm.AmountToCollect = response.recordsets[5]
              }
              // if (response && response.recordsets[6]) {
              //   vm.propertyList = response.recordsets[6]
              // }
              if (response && response.recordsets[7]) {
                vm.sourcesList = response.recordsets[7]
              }
              if (response && response.recordsets[8]) {
                vm.SubEventList = response.recordsets[8]
              }

              if (response && response.recordsets[10]) {
                console.log("response.recordsets[9]", response.recordsets[10])
                vm.TemplateTypes = response.recordsets[10];
                // if (response.recordsets[10].length >= 1) {
                //   vm.checkedCategoriesTypes = [];
                //   vm.checkedCategories = [];
                //   for (var i = 0; i < vm.TemplateTypes.length; i++) {
                //     if (vm.TemplateTypes[i]["IsChecked"] == 1)
                //       vm.checkedCategories.push(vm.TemplateTypes[i]["TemplateTypeId"]);
                //     vm.checkedCategoriesTypes = vm.checkedCategories.join(",");
                //   }
                // }


              }

              if (response && response.recordsets[9]) {
                vm.botdetails = response.recordsets[9][0];
                vm.Bot_Status =
                  response.recordsets[9][0].StatusId === null ||
                    response.recordsets[9][0].StatusId === undefined ||
                    response.recordsets[9][0].StatusId === "" ||
                    response.recordsets[9][0] === ""
                    ? { StatusId: "1", StatusName: "Active" }
                    : {
                      StatusId: response.recordsets[9][0].StatusId,
                      StatusName: response.recordsets[9][0].StatusName
                    };
                vm.Event.BotEvent_Name = response.recordsets[9][0].BotEvent_Name;
                vm.Event.BotEvent_Id = response.recordsets[9][0].EventId;
                vm.Event.EntityId = response.recordsets[9][0].EntityId;
                vm.entity.EntityId = response.recordsets[9][0].EntityId;
                vm.entity.EntityName = response.recordsets[9][0].EntityName;
                vm.selectedTemplate.TemplateId = response.recordsets[9][0].TemplateId;
                vm.selectedTemplate.TemplateName = response.recordsets[9][0].TemplateName;
                console.log("response.recordsets[9][0].TemplateName", response.recordsets[9][0].TemplateName);
                vm.searchTemplate = response.recordsets[9][0].TemplateName;


                // vm.botdetails.SubEventid = response.recordsets[8][0].SubEventId;
                // if (response.recordsets[9][0]) {
                //   if (response.recordsets[9][0].EventId == 3 || response.recordsets[9][0].EventId == 2) {
                //     console.log("response.recordsets[8][0].BotEvent_Id", response.recordsets[9][0].EventId)
                //     vm.displayEvent = true;
                //   }
                //   else {
                //     vm.displayEvent = false;
                //   }
                // }
                vm.AmountObj = response.recordsets[9][0].AmountPatternId || response.recordsets[9][0].AmountPatternName
                  ? { PatternId: response.recordsets[9][0].AmountPatternId, PatternDescription: response.recordsets[9][0].AmountPatternName } :
                  { PatternId: null, PatternDescription: null };
                vm.TransactionTypeobj = response.recordsets[9][0].PaymentTransactionTypeId || response.recordsets[9][0].PaymentTransactionTypeName
                  ? { transactionTypeID: response.recordsets[9][0].PaymentTransactionTypeId, transactionTypeName: response.recordsets[9][0].PaymentTransactionTypeName } :
                  { transactionTypeID: null, transactionTypeName: null };
                vm.property.PropertyId = response.recordsets[9][0].PropertyId;
                vm.property.PropertyName = response.recordsets[9][0].PropertyName;
                vm.property.propertyNickName = response.recordsets[9][0].propertyNickName;
                // if (response.recordsets[9][0].SubEventId == 11) {
                //   vm.schedularobj = { SubEventId: response.recordsets[9][0].SubEventId, name: "on" }
                // }
                // if (response.recordsets[9][0].SubEventId == 12) {
                //   vm.schedularobj = { SubEventId: response.recordsets[9][0].SubEventId, name: "before" };
                //   vm.showNumberofDays = true
                // }
                if (response.recordsets[9][0].SubEventId != null) {
                  vm.selectedSubEventIdList = JSON.parse("[" + response.recordsets[9][0].SubEventId + "]");
                  vm.prevoiusSelectedSubEventIdList = JSON.parse("[" + response.recordsets[9][0].SubEventId + "]");
                  vm.SubEventObj = { SubEventId: response.recordsets[9][0].SubEventId, SubEvent_Name: response.recordsets[9][0].SubEvent_Name }
                  // vm.displayEvent = true
                  if (response.recordsets[9][0].SubEventId == 4 || response.recordsets[9][0].SubEventId == 5 || response.recordsets[9][0].SubEventId == 7 || response.recordsets[9][0].SubEventId == 8) {
                    vm.showNumberofDays = true
                  }
                  else {
                    vm.showNumberofDays = false;
                  }
                }
                if (response.recordsets[9][0].EventId) {
                  vm.displayEvent = true;
                }
                // else{
                //   vm.displayEvent = false;
                // }

                if (response.recordsets[9][0].AmountPatternId) {
                  vm.showAmountlabel = true;
                }


                // if (response.recordsets[8][0].SubEventId == 12 || response.recordsets[8][0].SubEventId == 13) {

                // }
                // else {
                //   vm.showNumberofDays = false
                // }

                if (response.recordsets[9][0].SubEventId == 14 || response.recordsets[9][0].SubEventId == 15) {
                  vm.displaySubEvent = true;
                }
                else {
                  vm.displaySubEvent = false;
                }

              }
              if (response && response.recordsets[9][0].BotId) {
                vm.BotId = response.recordsets[9][0].BotId;
                vm.botTypedisable = true
              } else {
                vm.BotId = -1;
              }
              if (response && response.recordsets[11]) {
                vm.Templates = response.recordsets[11];

              }
              if (response && response.recordsets[12]) {
                vm.ApplyNotifyList = response.recordsets[12];

              }
              // if (response.recordsets[13]) {
              // console.log("response.recordsets[12]", response.recordsets[13]);
              // vm.ApplySourceList = response.recordsets[13];/

              // }
              for (let source in vm.ApplySourceList) {
                var sourceIndex = vm.sourcesList.map(function (x) { return x.sourceId; }).indexOf(vm.ApplySourceList[source].sourceId);
                if (sourceIndex > -1) {
                  vm.sourcesList.splice(sourceIndex, 1);
                }
                // if(vm.ApplySourceList[source].sourceId == -1){
                //   vm.ApplySourceList.splice(source,1)
                // }
              }

              // notify

              if (response.recordsets[14]) {
                console.log("response.recordsets[12]", response.recordsets[14]);
                vm.NotificationList = response.recordsets[14];



                // if (response.recordsets[8].length) {
                // scope.ApplyAmenitiesList = response.recordsets[8];
                // scope.showLessAmenities = response.recordsets[8].slice(0, 8);
                // console.log("ApplyAmenitiesList", scope.ApplyAmenitiesList);

                function findIndexByKeyValue(arraytosearch, key, valuetosearch) {
                  console.log("arraytosearch", key);
                  for (var i = 0; i < arraytosearch.length; i++) {
                    if (arraytosearch[i][key] == valuetosearch) {
                      return i;
                    }
                  }
                  return null;
                }

                for (var i in vm.ApplyNotifyList) {
                  var index = findIndexByKeyValue(
                    vm.NotificationList,
                    "Id",
                    vm.ApplyNotifyList[i].Id
                  );

                  if (index > -1) {
                    vm.NotificationList.splice(index, 1);
                  }
                }
              }

              if (response.recordsets && response.recordsets[15]) {
                vm.filteredUnitTypeList.splice(0);
                vm.filteredUnitList.splice(0)
                vm.filteredScopeData = response.recordsets[15]
                vm.getUnitTypeList(null, "getList");
                vm.getUnitNamesBySearchText(null, "getList");
              }
              // if (response.recordsets && response.recordsets[16]) {
              //   // vm.filteredPropertyList = response.recordsets[16];
              // }


              if (response.recordsets[13] && response.recordsets[13].length && response.recordsets[13][0].sourceId && response.recordsets[13][0].sourceId == -1) {

                vm.sourceToggle = true;
                vm.sourceLabel = response.recordsets[13][0];
              }
              else if (response.recordsets[13] && response.recordsets[13].length == 0) {
                vm.sourceToggle = true;
                vm.sourceLabel.sourceName = "All Sources"
              }
              else {
                vm.sourceToggle = false;
                vm.ApplySourceList = response.recordsets[13];
              }
              if (response.recordsets[15] && response.recordsets[15].length && response.recordsets[15][0].UnitId && response.recordsets[15][0].UnitId == -1) {

                vm.unitToggle = true;
                if (vm.botdetails.IsHostMode != 1) {
                  vm.unitLabel.UnitTypeName = "All Unit Types";

                }
                else {
                  vm.unitLabel.UnitNickName = "All Units";

                }


              }
              else if (response.recordsets[15] && response.recordsets[15].length == 0) {
                vm.unitToggle = true;
                if (vm.botdetails.IsHostMode != 1) {
                  vm.unitLabel.UnitTypeName = "All Unit Types";

                }
                else {
                  vm.unitLabel.UnitNickName = "All Units";
                }

              }
              else {
                vm.unitToggle = false;
                if (vm.botdetails.IsHostMode != 1) {
                  vm.unitLabel.UnitTypeName = "All Unit Types";

                }
                else {
                  vm.unitLabel.UnitNickName = "All Units";

                }
              }
              if (response.recordsets && response.recordsets[16] && response.recordsets[16].length && response.recordsets[16][0].PropertyId && response.recordsets[16][0].PropertyId == -1) {
                vm.propertyToggle = true;
                vm.propertyLabel = response.recordsets[16][0];

              }
              else if (response.recordsets && response.recordsets[16] && response.recordsets[16].length == 0) {
                vm.propertyToggle = true;
                vm.propertyLabel.PropertyName = "All Properties"

              }
              else {
                vm.propertyToggle = false;
                vm.filteredPropertyList = response.recordsets[16];

              }
            }
            // }
          }
        });

      },
      botSaveCloseModal() {
        let vm = this;
        this.isModalVisible = false;
        if (vm.saveBotAction == "savebotDetails") {
          vm.Save_BotDetails(false);
        } else if (vm.saveBotAction == "savebotScope") {
          vm.Save_BotScope(false);
        }
      },
      showModalView(saveBotAction) {
        let vm = this;
        let action = "";
        vm.saveBotAction = saveBotAction
        if (vm.Event.BotEvent_Id != 1) {
          vm.modalParams = {
            popupTitle: "Newly created bots or updates to existing bots will not Apply to Future Existing Reservations",
            popupMessage: "Would you like this update to reflect on Future Existing Reservations ?",
            displayYesNoButtons: true,
            yesButtontext: "Yes",
            noButtonText: "No",
            yesButtonCallback: vm.saveBotValues,
            noButtonCallback: vm.botSaveCloseModal
          };
          vm.isModalVisible = true;
        } else {
          if (vm.saveBotAction == "savebotDetails") {
            vm.Save_BotDetails(true);
          } else if (vm.saveBotAction == "savebotScope") {
            vm.Save_BotScope(true);
          }
        }
      },
      saveBotValues() {
        let vm = this;
        if (vm.saveBotAction == "savebotDetails") {
          vm.Save_BotDetails(true);
        } else if (vm.saveBotAction == "savebotScope") {
          vm.Save_BotScope(true);
        }
      },
      Save_BotScope(botsUpdate) {
        let vm = this;
        // let selectedarray;

        // // console.log("sourceidssourceids=>",vm.sourceids)
        // if (vm.ApplySourceList.length == 0) {
        //   vm.selectedSourceIds = '';
        //   selectedarray = ''
        // }
        // else {
        //   for (var index = 0; index < vm.ApplySourceList.length; index++) {
        //     console.log("vm.ApplySourceList[index].SourceId", vm.ApplySourceList[index].sourceId)
        //     vm.selectedSourceIds.push(vm.ApplySourceList[index].sourceId);
        //     // if(vm.sourceids){
        //     // vm.selectedSourceIds = vm.sourceids.join();
        //     // console.log("sourids============>", vm.selectedSourceIds)
        //     // }

        //   }
        //   // for(){

        //   // }
        //   selectedarray = vm.selectedSourceIds.join();
        // }

        // console.log("selectedarray", selectedarray);

        let unitIds = []
        if (vm.botdetails.IsHostMode == 1) {
          unitIds = vm.filteredUnitList.map(x => x.UnitId)
        } else {
          unitIds = vm.filteredUnitTypeList.map(x => x.UnitTypeId)
        }

        let propertyIds = vm.filteredPropertyList.map(x => x.PropertyId)

        // if (propertyIds.length <= 0) {
        //   vm.$store.dispatch("toastr", {
        //     type: "warning",
        //     message: "Please select the Property",
        //     header: "Warning!"
        //   });
        //   return
        // }
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_BotScope",
          params: {
            BotId: vm.$route.params.BotId,
            PropertyId: propertyIds ? propertyIds.join() : -1,
            SourceIds: vm.ApplySourceList,
            unitIds: unitIds.join(),
            IsHostMode: vm.botdetails.IsHostMode,
            EventId: vm.botdetails.EventId,
            botsUpdate: botsUpdate ? 1 : 0,
            SubeventId: vm.botdetails.SubEventId
          },
          callback: function (err, response) {
            if (err) {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Bots scope saving failed",
                header: "Error"
              });
              console.log("Save_BotScope error ", err)
              return;
            }
            else if (vm.botdetails.BotType_Id == 1) {

              console.log(response);
              vm.$store.dispatch("toastr", {
                type: "success",
                message: "MessangerBot scope saved sucessfully",
                header: "success"
              });


            }
            else if (vm.botdetails.BotType_Id == 2) {
              vm.$store.dispatch("toastr", {
                type: "success",
                message: "PaymentBot scope saved sucessfully",
                header: "success"
              });
            }
            vm.isModalVisible = false;
            vm.Get_BotDetails();
          }
        });
      },



      onChangeTemplate: function (template) {
        let vm = this;
        $(".searchResultsTemplate").hide();
        vm.selectedTemplate.TemplateName = template.TemplateName;
        vm.selectedTemplate.TemplateId = template.TemplateId;
        // vm.searchCountryOldValue = template.TemplateName;
        vm.searchTemplate = template.TemplateName;
        vm.searchTemplateOldValue = template.TemplateName;
        vm.templateList = [];
      },

    },
    computed: {
      
    },
    watch: {
      Event(value) {
        let vm = this;
        console.log("EventEventEventEventEvent", value);
        vm.addEvent(value);
      },
      filterSearchUnitNameText(searchText) {
        // if (searchText) {
        this.getUnitNamesBySearchText(searchText);
        // }
      },
      filterSearchUnitTypeNameText(searchText) {
        this.getUnitTypeList(searchText);
      },
      filterSearchPropertyNameText(searchText) {
        this.getPropertiesBySearchText(searchText)
      },
      searchTemplate(newValue, oldValue) {
        let vm = this;
        vm.templateList = [];

        vm.Templatevalueee = newValue;
        console.log("Templatevalueee", newValue)
        console.log("Firing search", newValue.length + newValue);
        if (vm.searchTemplateOldValue != vm.searchTemplate) {
          if (newValue.length > 0) {
            vm.$store.dispatch("dataRequestHandler", {
              key: "Get_TemplatesList",
              params: {
                ModuleAction: "Get_TemplatesList",
                StatusId: 1,
                SearchText: newValue
              },
              callback: function (err, response) {
                if (err) {
                  return;
                }
                if (response) {
                  console.log("response in search template", response);

                  if (
                    (newValue && oldValue) ||
                    (newValue && vm.$route.params.BotId == "-1")
                  ) {
                    vm.templateList = response;
                  }
                  // vm.templateList = response;
                }
              }
            });
          }
        }
      },
      propertyToggle(value) {
        let vm = this;
        if (value == true) {
          vm.filteredPropertyList = [];
          vm.propertyLabel.PropertyName = "All Properties"
        }
      },
      sourceToggle(value) {
        let vm = this;
        if (value == true) {
          vm.ApplySourceList = [];
          vm.sourceLabel.sourceName = "All Sources"
        }
      },
      unitToggle(value) {
        let vm = this;
        if (value == true) {
          vm.filteredUnitTypeList = [];
          vm.filteredUnitList = [];
          if (vm.botdetails.IsHostMode != 1) {
            vm.unitLabel.UnitTypeName = "All Unit Types";

          }
          else {
            vm.unitLabel.UnitNickName = "All Units";

          }
        }
      },




    },
    mounted() {
      let vm = this;
      vm.Get_BotDetails();
      vm.getUnitNamesBySearchText();
      vm.getUnitTypeList();
      $(document).click(function (e) {
        console.log("clicked on doc");
        $("#propertyDropdownlist").hide();
        $("#sourceDropdownlist").hide();
        $("#unitTypeDropdownlist").hide();
        $("#unitDropdownlist").hide();
        $("#searchResultsAmenities").hide();
        vm.getList = false;

      });
      $(document).click(function (e) {
        console.log("clicked on doc");
        $("#Notifydropdownlist").hide();

      })


      // vm.type = vm.$route.params.BotType
    },

  };
</script>